import { RestClient } from "clients/rest";
import { UseFormReturn } from "react-hook-form";

export type B090ZaikoChoseiRequest = {
  shohinCd: string;
  sokoCd: string;
  choseisu: string;
  choseiKbn: string;
} & Partial<{
  locationCd: string;
  meisaibiko: string;
}>;

export type B090040CreateRequest = {
  choseiYmd: string;
  shainCd: string;
  bumonCd: string;
  zaikoChoseiList: B090ZaikoChoseiRequest[];
};

// 登録処理
export const B090040Create = (props: B090040CreateRequest) => {
  return RestClient.post("b090040/create", props);
};

export type B090040GetRequestList = {
  b090040GetRequestList: B090040GetRequest[];
};

export type B090040GetRequest = {
  shohinCd: string;
  sokoshubetsuKbn: string;
  sokoCd: string;
  choseiKbn: string;
  choseisu: string;
} & Partial<{
  locaitonCd: string;
}>;

export type B090040GetResponse = {
  checkFlg: boolean;
  warnMessage: string;
};

// 明細部データチェック処理
export const B090040Get = (props: B090040GetRequestList) => {
  return RestClient.post("b090040/get", props);
};

export type B090040GetLocationCdRequest = Partial<{
  shohinCd: string;
  sokoCd: string;
}>;

export const B090040GetLocationCd = (props: B090040GetLocationCdRequest) => {
  return RestClient.get("b090040/get/location", { params: props });
};

export const B090040GetLocatoinCdByShohinCdSokoCd = async (
  meiMethods: UseFormReturn
) => {
  const meiFields = meiMethods.getValues();

  const param: B090040GetLocationCdRequest = {
    shohinCd: meiFields.shohinCd,
    sokoCd: meiFields.sokoCd,
  };

  await B090040GetLocationCd(param)
    .then((response) => {
      meiMethods.setValue("locationCd", response.data.locationCd);
    })
    .catch(() => {
      meiMethods.setValue("locationCd", "");
    });
};
